import { Loading } from 'components/loading/Loading';
import React, { useState } from 'react';
import styles from './index.module.scss';

const SingleAction = props => {
  const { action, disabled, onClick } = props;
  const [loading, setLoading] = useState<boolean>(false);
  
  const handleClick = async (onClick: Function) => {
    setLoading(true);
    try {
      await onClick();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <div
      className={`${styles['menu-item']} ${action.customClass} ${disabled && styles['disabled']}`}
      onClick={() => handleClick(onClick)}
    >
      {loading ? (
        <Loading type={'mini'} />
      ): action.text}
    </div>
  );
};

export default SingleAction;